// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gportal/api/support/v1/support_infos.proto (package gportal.api.support.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { SupportAddonSettings } from "./support_addons_pb.js";

/**
 * @generated from message gportal.api.support.v1.SupportCategoryServer
 */
export class SupportCategoryServer extends Message<SupportCategoryServer> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string server_address = 3;
   */
  serverAddress = "";

  constructor(data?: PartialMessage<SupportCategoryServer>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.SupportCategoryServer";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "server_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupportCategoryServer {
    return new SupportCategoryServer().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupportCategoryServer {
    return new SupportCategoryServer().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupportCategoryServer {
    return new SupportCategoryServer().fromJsonString(jsonString, options);
  }

  static equals(a: SupportCategoryServer | PlainMessage<SupportCategoryServer> | undefined, b: SupportCategoryServer | PlainMessage<SupportCategoryServer> | undefined): boolean {
    return proto3.util.equals(SupportCategoryServer, a, b);
  }
}

/**
 * @generated from message gportal.api.support.v1.SupportCategory
 */
export class SupportCategory extends Message<SupportCategory> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string parent_id = 2;
   */
  parentId = "";

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: optional string loco_key = 4;
   */
  locoKey?: string;

  /**
   * @generated from field: repeated gportal.api.support.v1.SupportCategoryServer customer_servers = 5;
   */
  customerServers: SupportCategoryServer[] = [];

  /**
   * @generated from field: repeated gportal.api.support.v1.SupportAddonSettings available_addons = 6;
   */
  availableAddons: SupportAddonSettings[] = [];

  constructor(data?: PartialMessage<SupportCategory>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gportal.api.support.v1.SupportCategory";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "parent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "loco_key", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "customer_servers", kind: "message", T: SupportCategoryServer, repeated: true },
    { no: 6, name: "available_addons", kind: "message", T: SupportAddonSettings, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SupportCategory {
    return new SupportCategory().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SupportCategory {
    return new SupportCategory().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SupportCategory {
    return new SupportCategory().fromJsonString(jsonString, options);
  }

  static equals(a: SupportCategory | PlainMessage<SupportCategory> | undefined, b: SupportCategory | PlainMessage<SupportCategory> | undefined): boolean {
    return proto3.util.equals(SupportCategory, a, b);
  }
}

